import './SlideGeneratorAdmin.scss';
import { useState } from 'react';
import { InputGroupManager } from './InputGroupManager';
import { Blueprints } from './Blueprints';
import { Page } from '../../Components/Page';

const Tab = {
  INPUT_GROUP_MANAGER: 'input-group-manager',
  BLUEPRINTS: 'blueprints'
} as const;
type TabType = (typeof Tab)[keyof typeof Tab];

const NAVS = [
  { label: 'Blueprints', key: Tab.BLUEPRINTS },
  { label: 'Input Groupings', key: Tab.INPUT_GROUP_MANAGER }
];

const isTab = (value: string): value is TabType => Object.values(Tab).some(tab => tab === value);

export const SlideGeneratorAdmin = () => {
  const [selectedTab, setSelectedTab] = useState<TabType>(Tab.BLUEPRINTS);

  return (
    <Page
      title='Slide Generator Admin'
      pageType='Slide Generator Admin'
      navs={NAVS}
      selectedNav={selectedTab}
      onNav={nav => {
        if (isTab(nav)) {
          setSelectedTab(nav);
        }
      }}
    >
      <div className='slide-generator-admin'>
        {selectedTab === Tab.BLUEPRINTS ? <Blueprints /> : <InputGroupManager />}
      </div>
    </Page>
  );
};
